module.exports = __webpack_public_path__ + "static/media/mycart_product_2.9c67a1e6.png";